import React, { useState } from 'react';
import { Menu, X, Phone, Mail, Instagram, Facebook, Twitter } from 'lucide-react';
import { Button } from './ui/Button';
interface HeaderProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Header({
  currentPage,
  onNavigate
}: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navItems = [{
    name: 'Home',
    id: 'home'
  }, {
    name: 'About Us',
    id: 'about'
  }, {
    name: 'Services',
    id: 'services'
  }, {
    name: 'Helpful Info',
    id: 'info'
  }, {
    name: 'Products',
    id: 'products'
  }, {
    name: 'Contact',
    id: 'contact'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-139">
      {/* Main Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="flex justify-between items-center h-20" data-id="element-141">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => onNavigate('home')} data-id="element-142">
            <img src="https://www.wearhaus.net/uploaded%2Fimages%2FRedesign%2FWearHausDesigns-logo%201.png" alt="Wear Haus Designs" className="h-12 w-auto" data-id="element-143" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-144">
            {navItems.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`text-sm font-medium transition-colors hover:text-wh-pink ${currentPage === item.id ? 'text-wh-pink' : 'text-gray-700'}`} data-id="element-145">
                {item.name}
              </button>)}
          </nav>

          {/* Desktop Icons & CTAs */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-146">
            {/* Contact & Social Icons */}
            <div className="flex items-center space-x-3 mr-4 pr-4 border-r border-gray-200" data-id="element-147">
              <a href="tel:260-463-7373" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Call us" data-id="element-148">
                <Phone className="w-4 h-4" data-id="element-149" />
              </a>
              <a href="mailto:wearhaus@wearhaus.net" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Email us" data-id="element-150">
                <Mail className="w-4 h-4" data-id="element-151" />
              </a>
              <a href="#" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Facebook" data-id="element-152">
                <Facebook className="w-4 h-4" data-id="element-153" />
              </a>
              <a href="#" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Instagram" data-id="element-154">
                <Instagram className="w-4 h-4" data-id="element-155" />
              </a>
              <a href="#" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Twitter" data-id="element-156">
                <Twitter className="w-4 h-4" data-id="element-157" />
              </a>
            </div>

            {/* CTA Buttons */}
            <Button variant="outline" size="sm" onClick={() => onNavigate('contact')} data-id="element-158">
              Contact
            </Button>
            <Button variant="primary" size="sm" onClick={() => onNavigate('contact')} data-id="element-159">
              Get a Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden" data-id="element-160">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-gray-600 hover:text-wh-pink hover:bg-gray-100 focus:outline-none" data-id="element-161">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-162" /> : <Menu className="h-6 w-6" data-id="element-163" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100" data-id="element-164">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-165">
            {navItems.map(item => <button key={item.id} onClick={() => {
          onNavigate(item.id);
          setIsMobileMenuOpen(false);
        }} className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium ${currentPage === item.id ? 'text-wh-pink bg-pink-50' : 'text-gray-700 hover:text-wh-pink hover:bg-gray-50'}`} data-id="element-166">
                {item.name}
              </button>)}

            {/* Mobile Contact Icons */}
            <div className="flex items-center justify-center space-x-6 py-4 border-t border-gray-100" data-id="element-167">
              <a href="tel:260-463-7373" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Call us" data-id="element-168">
                <Phone className="w-5 h-5" data-id="element-169" />
              </a>
              <a href="mailto:wearhaus@wearhaus.net" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Email us" data-id="element-170">
                <Mail className="w-5 h-5" data-id="element-171" />
              </a>
              <a href="#" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Facebook" data-id="element-172">
                <Facebook className="w-5 h-5" data-id="element-173" />
              </a>
              <a href="#" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Instagram" data-id="element-174">
                <Instagram className="w-5 h-5" data-id="element-175" />
              </a>
              <a href="#" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Twitter" data-id="element-176">
                <Twitter className="w-5 h-5" data-id="element-177" />
              </a>
            </div>

            <div className="pt-2 space-y-2 px-3" data-id="element-178">
              <Button variant="outline" className="w-full justify-center" onClick={() => onNavigate('contact')} data-id="element-179">
                Contact
              </Button>
              <Button variant="primary" className="w-full justify-center" onClick={() => onNavigate('contact')} data-id="element-180">
                Get a Quote
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}